import React from 'react';
import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Column } from 'components/shared/Layout';
import TextInput from 'components/ui/TextInput';
import { emailReg, isValidName } from 'utils/validators';
import { StyledRow, ErrorMessage, StyledLabel, StyledTitle } from 'pages/CreateVoucher/CreateVoucher.styles';

const RecipientDetailsForm = ({ errors, defaultValues }) => {
  const { register } = useFormContext();

  return (
    <>
      <StyledTitle>
        <FormattedMessage id="createVoucher.recipientDetails" />
      </StyledTitle>
      <StyledRow columns={12}>
        <Column alignItems="flex-start" flexDirection="column" span={3}>
          <StyledLabel htmlFor="firstName">
            <FormattedMessage id="extrasOnlyBookings.fields.firstName" />
          </StyledLabel>
          <TextInput
            data-cy="first-name"
            id="firstName"
            width="100%"
            {...register('firstName', { required: true, validate: isValidName })}
            defaultValue={defaultValues.firstName}
          />
          {errors.firstName && (
            <ErrorMessage>
              <FormattedMessage id="extrasOnlyBookings.errors.firstName" />
            </ErrorMessage>
          )}
        </Column>

        <Column alignItems="flex-start" flexDirection="column" span={3} start={5}>
          <StyledLabel htmlFor="lastName">
            <FormattedMessage id="extrasOnlyBookings.fields.lastName" />
          </StyledLabel>
          <TextInput
            data-cy="last-name"
            id="lastName"
            width="100%"
            {...register('lastName', { required: true, validate: isValidName })}
            defaultValue={defaultValues.lastName}
          />
          {errors.lastName && (
            <ErrorMessage>
              <FormattedMessage id="extrasOnlyBookings.errors.lastName" />
            </ErrorMessage>
          )}
        </Column>

        <Column alignItems="flex-start" flexDirection="column" span={3} start={9}>
          <StyledLabel htmlFor="recipientEmail">
            <FormattedMessage id="extrasOnlyBookings.fields.email" />
          </StyledLabel>
          <TextInput
            data-cy="recipientEmail"
            id="recipientEmail"
            width="100%"
            {...register('recipientEmail', { required: true, pattern: emailReg })}
            defaultValue={defaultValues.recipientEmail}
          />
          {errors.recipientEmail && (
            <ErrorMessage>
              <FormattedMessage id="createVoucher.errors.email" />
            </ErrorMessage>
          )}
        </Column>
      </StyledRow>
    </>
  );
};

RecipientDetailsForm.propTypes = {
  errors: PropTypes.shape({
    firstName: PropTypes.bool,
    lastName: PropTypes.bool,
    recipientEmail: PropTypes.bool
  }),
  defaultValues: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    recipientEmail: PropTypes.string
  })
};

export default RecipientDetailsForm;
